import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import { css } from "@emotion/react"
import { rgba } from "polished"

import { fontSize, globalColors } from "../components/css-functions"

const TopNewsList = () => {
  const { allMarkdownRemark } = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "latest-page"}}}, sort: {order: DESC, fields: frontmatter___date}, limit: 3) {
        edges {
          node {
            frontmatter {
              title
            }
            id
          }
        }
      }
    }
  `)

  const style = {
    wrapper: css`
      padding: 8px 20px 20px;
      width: 280px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: ${ rgba(globalColors.white, 0.6) };
      position: relative;
      color: ${ globalColors.black };
    `,
    title: css`
      ${ fontSize(18) }
      letter-spacing: 0.3em;
    `,
    list: css`
      margin-top: 8px;
    `,
    listItem: css`
      &:not(:last-of-type) {
        margin-bottom: 8px;
      }
      ${ fontSize(14) }
    `,
    link: css`
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: ${ globalColors.black };
      &:visited {
        color: ${ globalColors.black };
      }
    `,
    border: css`
      position: absolute;
      background-color: ${ globalColors.white };
      &.t {
        width: 100%;
        height: 1px;
        top: -6px;
        left: 0;
        animation: frameHz 0.8s ease-out;
      }
      &.r {
        width: 1px;
        height: 100%;
        top: 0;
        right: -6px;
        animation: frameVt 0.8s ease-out;
      }
      &.b {
        width: 100%;
        height: 1px;
        bottom: -6px;
        right: 0;
        animation: frameHz 0.8s ease-out;
      }
      &.l {
        width: 1px;
        height: 100%;
        bottom: 0;
        left: -6px;
        animation: frameVt 0.8s ease-out;
      }
      @keyframes frameHz {
        0% {
          width: 0;
        }
        100% {
          width: 100%;
        }
      }
      @keyframes frameVt {
        0% {
          height: 0;
        }
        100% {
          height: 100%;
        }
      }
    `,
  }

  return (
    <section css={ style.wrapper }>
      <h3 css={ style.title }>最新情報</h3>
      <ul css={ style.list }>
        { allMarkdownRemark.edges.map(({ node }) => (
          <li
            key={ node.id }
            css={ style.listItem }
          >
            <Link
              to={ `/news/#latest-${ node.id }` }
              css={ style.link }
            >
              { node.frontmatter.title }
            </Link>
          </li>
        ))}
      </ul>
      <div css={ style.border } className="t"></div>
      <div css={ style.border } className="r"></div>
      <div css={ style.border } className="b"></div>
      <div css={ style.border } className="l"></div>
    </section>
  )
}

export default TopNewsList